import React from "react";
import { Footer } from "../components";


const NotFound = () => (
  <div style={{ textAlign: "center", background: "white" }}>
    <h1>Not Found!!!</h1>
    <Footer />
  </div>
);

export default NotFound;
